export default __webpack_public_path__ + "static/media/logo.68cbf6cf.jpg";